// The frame for the few pages that stand outside the app (the community rule, contact, privacy, a
// missing page): the mark at the top, one calm column set like a printed page, and the small links at
// the foot. Read mode: the words lead, nothing moves but the column's arrival.
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { Logo } from "./Logo";
import s from "./StaticPage.module.css";

export function StaticPage({ children, wide = false, centred = false }: { children: ReactNode; wide?: boolean; centred?: boolean }) {
  return (
    <div className={s.frame}>
      <header className={s.top}>
        <Link to="/" className={s.mark} aria-label="Fellowship, the front page">
          <Logo />
        </Link>
        <Link to="/home" className={s.back}>
          Back to Fellowship
        </Link>
      </header>
      <main id="main" className={[s.main, wide ? s.wide : "", centred ? s.centred : ""].filter(Boolean).join(" ")}>
        {children}
      </main>
      <footer className={s.foot}>
        <nav aria-label="About Fellowship">
          <Link to="/rules">Community rule</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </footer>
    </div>
  );
}

/** A page's title and its opening sentence. */
export function StaticHead({ title, lead, cite }: { title: ReactNode; lead?: ReactNode; cite?: string }) {
  return (
    <header className={s.head}>
      <h1 className={s.title}>{title}</h1>
      {cite && <p className={s.cite}>{cite}</p>}
      {lead && <p className={s.lead}>{lead}</p>}
    </header>
  );
}

export { s as staticStyles };
